import React, { useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaChartPie,
  FaBook,
  FaUserCog,
  FaSignOutAlt,
  FaClipboardList,
  FaExchangeAlt,
  FaFileInvoiceDollar,
  FaCity,
} from "react-icons/fa";

const Sidebar = ({
  image,
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
}) => {
  const { user, dispatch, setting } = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutButtonHandler = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGOUT" });
    navigate("/");
  };

  return (
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      onToggle={handleToggleSidebar}
      breakPoint="md"
    >
      {/* Header */}
      <SidebarHeader>
        <Menu iconShape="circle">
          {collapsed ? (
            <MenuItem
              icon={<FaAngleDoubleRight />}
              onClick={handleCollapsedChange}
            ></MenuItem>
          ) : (
            <MenuItem
              suffix={<FaAngleDoubleLeft />}
              onClick={handleCollapsedChange}
            >
              <div
                style={{
                  padding: "9px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: 15,
                  letterSpacing: "1px",
                }}
              >
                {setting.namaProgram} {setting.namaSoftware}
              </div>
            </MenuItem>
          )}
        </Menu>
      </SidebarHeader>
      {/* Content */}
      <SidebarContent>
        <Menu iconShape="circle">
          <SubMenu title={"Dashboard"} icon={<FaChartPie />}></SubMenu>
          <SubMenu title={"Master"} icon={<FaBook />}>
            {user.akses.bukuBesar === true && (
              <SubMenu title={"Buku Besar"}>
                <MenuItem>
                  Kelompok COA <NavLink to="/jenisCoa" />
                </MenuItem>
                <MenuItem>
                  Group COA <NavLink to="/groupCoa" />
                </MenuItem>
                <MenuItem>
                  SubGroup COA <NavLink to="/subGroupCoa" />
                </MenuItem>
                <MenuItem>
                  COA <NavLink to="/coa" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.area === true && (
              <SubMenu title={"Area"}>
                <MenuItem>
                  Provinsi <NavLink to="/provinsi" />
                </MenuItem>
                <MenuItem>
                  Kabupaten / Kota <NavLink to="/kabupaten" />
                </MenuItem>
                <MenuItem>
                  Kecamatan <NavLink to="/kecamatan" />
                </MenuItem>
                {/* <MenuItem>
                  Kelurahan / Desa <NavLink to="/kelurahan" />
                </MenuItem> */}
              </SubMenu>
            )}
            {user.akses.stok === true && (
              <SubMenu title={"Stok"}>
                <MenuItem>
                  Group Stok <NavLink to="/groupStok" />
                </MenuItem>
                <MenuItem>
                  Stok <NavLink to="/stok" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.supplier === true && (
              <MenuItem>
                Supplier <NavLink to="/supplier" />
              </MenuItem>
            )}
            {user.akses.mekanik === true && (
              <MenuItem>
                Mekanik <NavLink to="/mekanik" />
              </MenuItem>
            )}
            {user.akses.customer === true && (
              <MenuItem>
                Customer <NavLink to="/customer" />
              </MenuItem>
            )}
            {user.akses.tipe === true && (
              <MenuItem>
                Tipe <NavLink to="/tipe" />
              </MenuItem>
            )}
            {user.akses.warna === true && (
              <MenuItem>
                Warna <NavLink to="/warna" />
              </MenuItem>
            )}
            {user.akses.jenisPembayaran === true && (
              <MenuItem>
                Jenis Pembayaran <NavLink to="/jenisPembayaran" />
              </MenuItem>
            )}
            {/* {user.akses.cabang === true && (
              <MenuItem>
                Cabang <NavLink to="/cabang" />
              </MenuItem>
            )} */}
          </SubMenu>
          <SubMenu title={"Transaksi"} icon={<FaExchangeAlt />}>
            {user.akses.pembelian === true && (
              <MenuItem>
                Pembelian <NavLink to="/daftarPembelian" />
              </MenuItem>
            )}
            {user.akses.returPembelian === true && (
              <MenuItem>
                Retur Pembelian <NavLink to="/daftarReturPembelian" />
              </MenuItem>
            )}
            {user.akses.pembayaranHutang === true && (
              <MenuItem>
                Pembayaran Hutang <NavLink to="/daftarPembayaranHutang" />
              </MenuItem>
            )}
            {user.akses.penjualan === true && (
              <MenuItem>
                Penjualan / Servis <NavLink to="/daftarPenjualan" />
              </MenuItem>
            )}
            {user.akses.pembayaranPiutang === true && (
              <MenuItem>
                Penerimaan Piutang <NavLink to="/daftarPembayaranPiutang" />
              </MenuItem>
            )}
            {user.akses.mutasiStok === true && (
              <MenuItem>
                Mutasi Stok <NavLink to="/daftarMutasiStok" />
              </MenuItem>
            )}
            {user.akses.rekalkulasiStok === true && (
              <MenuItem>
                Rekalkulasi Stok <NavLink to="/rekalkulasiStok" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Laporan"} icon={<FaClipboardList />}>
            {user.akses.laporanPembelian === true && (
              <SubMenu title={"Laporan Pembelian"}>
                <MenuItem>
                  Lap. Pembelian <NavLink to="/laporanPembelian" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.laporanPenjualan === true && (
              <SubMenu title={"Laporan Penjualan"}>
                <MenuItem>
                  Per Hari <NavLink to="/laporanPenjualanPerHari" />
                </MenuItem>
                <MenuItem>
                  Per Stok <NavLink to="/laporanPenjualanPerStok" />
                </MenuItem>
                <MenuItem>
                  Per Mekanik <NavLink to="/laporanPenjualanPerMekanik" />
                </MenuItem>
                <MenuItem>
                  Per Nota <NavLink to="/laporanPenjualanPerNota" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.laporanStok === true && (
              <SubMenu title={"Laporan Stok"}>
                <MenuItem>
                  Kartu Stok <NavLink to="/laporanStokKartuStok" />
                </MenuItem>
                <MenuItem>
                  Rekap Total Stok <NavLink to="/laporanStokRekapTotalStok" />
                </MenuItem>
                <MenuItem>
                  Export Stok <NavLink to="/laporanExportStok" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.laporanHutang === true && (
              <SubMenu title={"Laporan Hutang"}>
                <MenuItem>
                  Saldo Hutang <NavLink to="/laporanSaldoHutang" />
                </MenuItem>
                <MenuItem>
                  Total Hutang <NavLink to="/laporanTotalHutang" />
                </MenuItem>
                <MenuItem>
                  Kartu Hutang <NavLink to="/laporanKartuHutang" />
                </MenuItem>
                <MenuItem>
                  Hutang J. Tempo <NavLink to="/laporanHutangJatuhTempo" />
                </MenuItem>
                <MenuItem>
                  Pembayaran Hutang <NavLink to="/laporanPembayaranHutang" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.laporanKas === true && (
              <SubMenu title={"Laporan Kas"}>
                <MenuItem>
                  Penerimaan Kas <NavLink to="/laporanPenerimaanKas" />
                </MenuItem>
                <MenuItem>
                  Kas <NavLink to="/laporanKas" />
                </MenuItem>
              </SubMenu>
            )}
          </SubMenu>
          <SubMenu title={"Finance"} icon={<FaFileInvoiceDollar />}>
            {user.akses.kasMasuk === true && (
              <MenuItem>
                Kas Masuk <NavLink to="/daftarKasMasuk" />
              </MenuItem>
            )}
            {user.akses.kasKeluar === true && (
              <MenuItem>
                Kas Keluar <NavLink to="/daftarKasKeluar" />
              </MenuItem>
            )}
            {user.akses.bankMasuk === true && (
              <MenuItem>
                Bank Masuk <NavLink to="/daftarBankMasuk" />
              </MenuItem>
            )}
            {user.akses.bankKeluar === true && (
              <MenuItem>
                Bank Keluar <NavLink to="/daftarBankKeluar" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Accounting"} icon={<FaClipboardList />}>
            {user.akses.jurnalUmum === true && (
              <MenuItem>
                Jurnal Umum <NavLink to="/daftarJurnalUmum" />
              </MenuItem>
            )}
            {user.akses.jurnalUmum === true && (
              <MenuItem>
                Lap. Jurnal Umum <NavLink to="/laporanJurnalUmum" />
              </MenuItem>
            )}
            {user.akses.posting === true && (
              <MenuItem>
                Posting <NavLink to="/posting" />
              </MenuItem>
            )}
            {user.akses.unposting === true && (
              <MenuItem>
                Unposting <NavLink to="/unposting" />
              </MenuItem>
            )}
            {user.akses.aktivitasBukuBesar === true && (
              <MenuItem>
                Aktivitas Buku Besar <NavLink to="/aktivitasBukuBesar" />
              </MenuItem>
            )}
            {user.akses.neracaSaldo === true && (
              <MenuItem>
                Neraca Saldo <NavLink to="/neracaSaldo" />
              </MenuItem>
            )}
            {user.akses.labaRugi === true && (
              <MenuItem>
                Laba Rugi <NavLink to="/labaRugi" />
              </MenuItem>
            )}
            {user.akses.neraca === true && (
              <MenuItem>
                Neraca <NavLink to="/neraca" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Utility"} icon={<FaUserCog />}>
            {user.akses.profilUser === true && (
              <MenuItem>
                Profil User <NavLink to="/profilUser" />
              </MenuItem>
            )}
            {user.akses.daftarUser === true && (
              <MenuItem>
                Daftar User <NavLink to="/daftarUser" />
              </MenuItem>
            )}
            {user.akses.tutupPeriode === true && (
              <MenuItem>
                Tutup Periode
                <NavLink to="/tutupPeriode" />
              </MenuItem>
            )}
            {user.akses.gantiPeriode === true && (
              <MenuItem>
                Ganti Periode <NavLink to="/gantiPeriode" />
              </MenuItem>
            )}
            {user.tipeUser === "OWNER/DIREKSI" &&
              user.akses.setting === true && (
                <MenuItem>
                  Setting <NavLink to="/setting" />
                </MenuItem>
              )}
          </SubMenu>
        </Menu>
      </SidebarContent>
      {/* Footer */}
      <SidebarFooter style={{ textAlign: "center" }}>
        <p style={{ fontSize: "12px", marginTop: "10px" }}>{user.username}</p>
        <p style={{ fontSize: "12px", marginTop: "-10px" }}>
          Cabang : {user.cabang.namaCabang}
        </p>
        <div className="sidebar-btn-wrapper" style={{ paddingBottom: "10px" }}>
          <Link
            className="sidebar-btn"
            style={{ cursor: "pointer" }}
            to="/"
            onClick={logoutButtonHandler}
          >
            <span style={{ marginRight: "6px" }}>Logout</span>
            <FaSignOutAlt />
          </Link>
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default Sidebar;
